(function () {
    var MenuUtils = window.HeaderMenuUtils || (window.HeaderMenuUtils = (function () {
      function safeParseJSON(text) {
        try { return JSON.parse(text); } catch (e) { return null; }
      }
  
      function esc(s) {
        return String(s == null ? "" : s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      }
  
      function runWhenIdle(fn, timeout) {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(fn, { timeout: timeout || 800 });
        } else {
          setTimeout(fn, timeout ? Math.min(timeout, 200) : 100);
        }
      }
  
      function runAfterLoad(fn) {
        if (document.readyState === "complete") {
          runWhenIdle(fn);
        } else {
          window.addEventListener("load", function () {
            runWhenIdle(fn);
          }, { once: true });
        }
      }
  
      function debounce(fn, wait) {
        var t;
        return function () {
          var ctx = this;
          var args = arguments;
          clearTimeout(t);
          t = setTimeout(function () { fn.apply(ctx, args); }, wait || 140);
        };
      }
  
      function findByHandle(items, handle) {
        handle = String(handle || "");
        for (var i = 0; i < items.length; i++) {
          if (items[i] && String(items[i].handle) === handle) return items[i];
        }
        return null;
      }
  
      function createMenuDataStore(raw) {
        var dataParsed = false;
        var data = { items: [], settings: {} };
  
        function ensureData() {
          if (dataParsed) return;
          var parsed = raw ? safeParseJSON(raw) : null;
          data = parsed || { items: [], settings: {} };
          dataParsed = true;
        }
  
        return {
          getItem: function (handle) {
            ensureData();
            return findByHandle(data.items || [], handle);
          },
          getSettings: function () {
            ensureData();
            return data.settings || {};
          }
        };
      }
  
      return {
        safeParseJSON: safeParseJSON,
        esc: esc,
        runWhenIdle: runWhenIdle,
        runAfterLoad: runAfterLoad,
        debounce: debounce,
        findByHandle: findByHandle,
        createMenuDataStore: createMenuDataStore
      };
    })());
  
    function buildDrawerSubmenuHTML(item, settings) {
      if (!item || !item.children || !item.children.length) return "";
  
      var children = item.children;
      var html = '';
  
      html += '<ul class="menu-drawer__menu list-menu__item--ul-lv2 list-menu list-unstyled" role="list" tabindex="-1">';
  
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (!child) continue;
  
        var hasLv3 = child.children && child.children.length;
  
        html += '<li>';
  
        if (!hasLv3) {
        html += '<a class="menu-drawer__menu-item list-menu__item list-menu__item--lv2 link link--text focus-inset" href="' + MenuUtils.esc(child.url) + '">';
  
          if (child.image_64) {
            html += '<image-animation class="card__media-wrapper media-wrapper--style" data-image-animate="zoom-fade-in">';
            html += '  <div class="media media--transparent media--zoom" style="width: 6.4rem; padding-bottom: 100%;">';
          html += '    <img loading="lazy" width="46" height="46" src="' + MenuUtils.esc(child.image_64) + '" alt="' + MenuUtils.esc(child.title) + '">';
            html += '  </div>';
            html += '</image-animation>';
          } else if (settings.no_image_fallback) {
          html += '<img src="' + MenuUtils.esc(settings.no_image_fallback) + '" alt="No image" width="46" height="46" class="no-image" loading="lazy"/>';
          }
  
        html += '<span>' + MenuUtils.esc(child.title) + '</span>';
          html += '<svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-caret"></use></svg>';
          html += '</a>';
        } else {
          html += '<menu-details class="menu-details">';
          html += '  <details class="menu-drawer__dropdown menu-drawer__dropdown--lv2">';
          html += '    <summary class="menu-drawer__menu-item list-menu__item list-menu__item--lv2 link link--text focus-inset">';
        html += '      <span>' + MenuUtils.esc(child.title) + '</span>';
          html += '      <svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-menu-caret"></use></svg>';
          html += '    </summary>';
          html += '    <div class="menu-drawer__submenu gradient motion-reduce">';
          html += '      <div class="menu-drawer__heading">';
          html += '        <button type="button" class="menu-drawer__button text-body">';
          html += '          <svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-back-mobile"></use></svg>';
        html += '          <span>' + MenuUtils.esc(child.title) + '</span>';
          html += '        </button>';
          html += '      </div>';
  
          html += '      <ul class="menu-drawer__menu list-menu list-menu__item--ul-lv3 list-unstyled" role="list" tabindex="-1">';
          for (var j = 0; j < child.children.length; j++) {
            var grand = child.children[j];
            if (!grand) continue;
  
            html += '        <li class="' + (grand.image_180 ? 'has-image' : '') + '">';
          html += '          <a class="menu-drawer__menu-item list-menu__item list-menu__item--lv3 link link--text focus-inset" href="' + MenuUtils.esc(grand.url) + '">';
            if (grand.image_180) {
            html += '            <img loading="lazy" src="' + MenuUtils.esc(grand.image_180) + '" alt="' + MenuUtils.esc(grand.title) + '">';
            }
          html += '            <span>' + MenuUtils.esc(grand.title) + '</span>';
            html += '          </a>';
            html += '        </li>';
          }
          html += '      </ul>';
  
          var showTitle = false;
          for (var k = 0; k < child.children.length; k++) {
            if (child.children[k] && child.children[k].image_180) { showTitle = true; break; }
          }
          if (showTitle) {
          html += '      <div class="view-all"><a href="' + MenuUtils.esc(child.url) + '" class="link--hover"><span>Shop All</span></a></div>';
          }
  
          html += '    </div>';
          html += '  </details>';
          html += '</menu-details>';
        }
  
        html += '</li>';
      }
  
      html += '</ul>';
  
      var total = children.length;
      html += '<div class="footer-submemu" data-total="' + MenuUtils.esc(total) + '">';
      html += '  <a href="' + MenuUtils.esc(item.url) + '" class="link link--text link--hover" title="' + MenuUtils.esc(item.title) + '">';
      html += '    <span>Shop All (' + MenuUtils.esc(total) + ')</span>';
      html += '  </a>';
      html += '</div>';
  
      return html;
    }
  
    class HeaderDrawerMenu extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(max-width: 1024px)");
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.handleFirstInteraction = this.handleFirstInteraction.bind(this);
        this._isInteractive = false;
        this._pendingActivate = false;
      }

      connectedCallback() {
        this.bindFirstInteraction();
        this.handleMediaChange(this.mql);
        if (this.mql.addEventListener) {
          this.mql.addEventListener("change", this.handleMediaChange);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.handleMediaChange);
        }
      }

      initDataStore() {
        if (this._dataStoreInited) return;
        this._dataStoreInited = true;

        var jsonEl = document.getElementById("HeaderMenuJSON") || document.getElementById("DrawerMenuJSON") || this.querySelector("#DrawerMenuJSON");
        var raw = jsonEl ? (jsonEl.textContent || "").trim() : "";
        this.store = MenuUtils.createMenuDataStore(raw);
      }

      handleMediaChange(e) {
        var isMobile = !!(e && typeof e.matches === "boolean" ? e.matches : this.mql.matches);
        if (isMobile) {
          this._pendingActivate = true;
          this.activate();
        } else {
          this.deactivate();
        }
      }

      bindFirstInteraction() {
        if (this._interactionBound) return;
        this._interactionBound = true;
        var opts = { once: true, passive: true };
        window.addEventListener("pointerdown", this.handleFirstInteraction, opts);
        window.addEventListener("keydown", this.handleFirstInteraction, opts);
        window.addEventListener("touchstart", this.handleFirstInteraction, opts);
        window.addEventListener("mousemove", this.handleFirstInteraction, opts);
      }

      handleFirstInteraction() {
        this._isInteractive = true;
        if (this._pendingActivate) this.activate();
      }

      activate() {
        if (this._active || !this._isInteractive) return;
        this._active = true;

        this.initDataStore();
        this.bindLazy();
        this.prefetchCache();
      }

      deactivate() {
        if (!this._active) return;
        this._active = false;
        this._pendingActivate = false;

        if (this._onToggle) {
          this.removeEventListener("toggle", this._onToggle, true);
        }
        this._lazyBound = false;
      }

      bindLazy() {
        if (this._lazyBound) return;
        this._lazyBound = true;

        var self = this;

        this._onToggle = function (event) {
          var details = event.target;
          if (!details || details.tagName !== "DETAILS" || !details.open) return;

          var mountEl = details.querySelector("drawer-submenu-mount");
          if (!mountEl) return;

          var handle = mountEl.getAttribute("data-handle");
          var mount = mountEl.querySelector("[data-drawer-mount]");
          if (!handle || !mount) return;

          if (!mount.dataset.rendered) {
            var item = self.store.getItem(handle);
            var settings = self.store.getSettings();
            if (item && item.children && item.children.length) {
              mount.innerHTML = buildDrawerSubmenuHTML(item, settings);
              mount.dataset.rendered = "true";
            }
          }

          mount.hidden = false;
        };

        this.addEventListener("toggle", this._onToggle, true);
      }

      prefetchCache() {
        var self = this;

        var run = function () {
          if (!self._active) return;
          var nodes = self.querySelectorAll("drawer-submenu-mount [data-drawer-mount]");
          var i = 0;

          var step = function () {
            if (!self._active) return;
            var start = Date.now();
            while (i < nodes.length && (Date.now() - start) < 12) {
              var mount = nodes[i];
              i += 1;

              if (!mount || mount.dataset.rendered) continue;

              var host = mount.closest("drawer-submenu-mount");
              var handle = host ? host.getAttribute("data-handle") : null;
              if (!handle) continue;

              var item = self.store.getItem(handle);
              var settings = self.store.getSettings();
              mount.innerHTML = buildDrawerSubmenuHTML(item, settings);
              mount.dataset.rendered = "true";
              mount.hidden = true;
            }

            if (i < nodes.length) {
              if ("requestIdleCallback" in window) {
                requestIdleCallback(step, { timeout: 600 });
              } else {
                setTimeout(step, 50);
              }
            }
          };

          step();
        };

        MenuUtils.runAfterLoad(run);
      }

      disconnectedCallback() {
        if (this.mql && this.mql.removeEventListener) {
          this.mql.removeEventListener("change", this.handleMediaChange);
        } else if (this.mql && this.mql.removeListener) {
          this.mql.removeListener(this.handleMediaChange);
        }

        if (this._onToggle) {
          this.removeEventListener("toggle", this._onToggle, true);
        }
      }
    }
      
  
    class HeaderMenuMover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(max-width: 1024px)");
        this.handleResize = this.handleResize.bind(this);
        this.handleResizeDebounced = MenuUtils.debounce(this.handleResize, 160);
        this._lastIsMobile = null;
        this._lastSignature = null;
      }
  
      connectedCallback() {
        const root = (this.getRootNode && this.getRootNode()) || document;
  
        this.hotlineEl = root.querySelector(".header__hotline");
        this.menuSmallEl = root.querySelector(".header__menu-small");
        this.mobileTarget = root.querySelector(".header-menu-bottom-mobile");
  
        if (!this.hotlineEl || !this.menuSmallEl || !this.mobileTarget) return;
  
        this.hotlineOriginalParent = this.hotlineEl.parentElement;
        this.menuChildren = Array.from(this.menuSmallEl.children);
  
        this.handleResize({ matches: this.mql.matches });
  
        if (this.mql.addEventListener) {
          this.mql.addEventListener("change", this.handleResizeDebounced);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.handleResizeDebounced);
        }
      }
  
      disconnectedCallback() {
        if (this.mql && this.mql.removeEventListener) {
          this.mql.removeEventListener("change", this.handleResizeDebounced);
        } else if (this.mql && this.mql.removeListener) {
          this.mql.removeListener(this.handleResizeDebounced);
        }
      }
  
      handleResize(e) {
        const isMobile = !!(e && typeof e.matches === "boolean" ? e.matches : this.mql.matches);
        const signature = this.getStructureSignature();
  
        if (this._lastIsMobile === isMobile && this._lastSignature === signature) {
          return;
        }
  
        if (isMobile) {
          this.menuChildren.forEach((child) => {
            if (!this.mobileTarget.contains(child)) this.mobileTarget.appendChild(child);
          });
          if (!this.mobileTarget.contains(this.hotlineEl)) this.mobileTarget.appendChild(this.hotlineEl);
        } else {
          if (this.hotlineOriginalParent && !this.hotlineOriginalParent.contains(this.hotlineEl)) {
            this.hotlineOriginalParent.appendChild(this.hotlineEl);
          }
          this.menuChildren.forEach((child) => {
            if (!this.menuSmallEl.contains(child)) this.menuSmallEl.appendChild(child);
          });
        }
  
        this._lastIsMobile = isMobile;
        this._lastSignature = this.getStructureSignature();
      }
  
      getStructureSignature() {
        if (!this.menuSmallEl || !this.mobileTarget) return "";
        var hotlineState = this.hotlineEl
          ? (this.hotlineEl.parentElement === this.mobileTarget ? "m" : "d")
          : "n";
        return [
          this.menuSmallEl.children.length,
          this.mobileTarget.children.length,
          hotlineState
        ].join("|");
      }
    }
  
    if (!customElements.get("header-drawer-menu")) {
      customElements.define("header-drawer-menu", HeaderDrawerMenu);
    }
  
    if (!customElements.get("header-menu-mover")) {
      customElements.define("header-menu-mover", HeaderMenuMover);
    }
  })();
  